module.exports = __webpack_public_path__ + "static/media/insights.ace02f48.svg";